export const CustomizationStyle = {
	mainWrapper: {
		display: 'flex',
		gap: '20px',
		height: '100%',

		'@media (min-width: 1200px)': {
			minHeight: 'calc(100vh - 128px)',
			maxHeight: 'fit-content',
		},
	},
	leftBoxWrapper: {
		width: '50%',
		background: 'var(--default-white)',
		borderRadius: '8px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		boxShadow: 'var(--box-shadow--1)',
	},
	heading: {
		width: '100%',
		px: '24px',
		py: '12px',
		borderBottom: '1px solid var(--neutral-100)',
		fontWeight: '700',
		color: 'var(--neutral-900)',
	},
	checkBoxContainer: {padding: '16px 24px 24px 24px'},
	logoText: {color: 'var(--neutral-200)', fontSize: '12px', mt: '12px'},
	buttonsBlock: {display: 'flex', px: '24px', gap: '24px', pb: '24px'},
	rightBoxWrapper: {
		width: '50%',
		background: 'var(--default-white)',
		borderRadius: '8px',
		height: '100%',
		boxShadow: 'var(--box-shadow--1)',
	},
	rightHeading: {
		width: '100%',
		px: '24px',
		py: '12px',
		borderBottom: '1px solid var(--neutral-100)',
		fontWeight: '700',
		color: 'var(--neutral-900)',
	},
	sceletonWrapper: {
		width: '100%',
		minHeight: '90%',
		bgcolor: '#f1f2f5',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		py: 4,
	},
	sceletonBox: {
		bgcolor: 'white',
		width: 360,
		height: 640,
		px: 3,
		py: 4,
		boxShadow: 3,
		borderRadius: 1,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		position: 'relative',
	},
	logoPosition: {position: 'absolute', top: '16px', left: '16px'},

	logo: {
		marginTop: '20px',
		maxHeight: '100px',

		'& .MuiFormLabel-root': {
			position: 'absolute',
			top: '-20px',
		},
	},

	logoWrapper: {
		height: '100px',
		marginBottom: '20px',
	},
};
